import { cn } from '@/lib/utils';
import { ActiveOrInactiveIcon } from './active-or-inactive-icon';
import type { FeatureTableBody } from '../types';

interface AccordionTableContentProps {
  accordionItem: FeatureTableBody;
  tableHeadingMobile: string[];
}

const AccordionTableContent = ({
  accordionItem,
  tableHeadingMobile,
}: AccordionTableContentProps) => {
  return (
    <table className="w-full border-separate border-spacing-[2px] overflow-hidden rounded-[10px]">
      <thead className="p-3">
        <tr className="w-full gap-[2px]">
          {tableHeadingMobile.map((heading: string, index: number) => {
            return (
              <th
                key={index}
                className={cn(
                  `text-white font-nunito700 text-sm py-[10px] px-[8px] bg-black w-1/4 text-center`,
                  {
                    'w-1/2 text-left': index === 0,
                    'gradient-column text-black': index === 2,
                  }
                )}
              >
                {heading}
              </th>
            );
          })}
        </tr>
      </thead>
      <tbody className="text-grey-900">
        {accordionItem.content.map((item, index: number) => {
          return (
            <tr key={index}>
              <td className="p-[10px] text-sm bg-light-grey-200">
                {item.text}
              </td>
              <td className="p-[10px] bg-light-grey-200">
                <ActiveOrInactiveIcon isActive={item.version_1} />
              </td>
              <td className="px-[10px] bg-light-grey-200">
                <ActiveOrInactiveIcon isActive={item.version_2} />
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export { AccordionTableContent };
